import SmartTagAdapter from './shared/smart-tag-adapter';
import GeoLocationService from '../services/GeoLocationService';
import Domain from '../helpers/Domain';

export default function (playerParams, initSmartTagPlugins) {
    const obj = this;

    let smartTag;

    this.streamType = null;
    this.enableCP = false;
    this.showId = null;
    this.baseUrl = null;
    this.apiMetadata = null;
    this.millstone = null;
    this.lowbandEnabled = false;
    this.playerParams = playerParams;

    this.drmTemplate = {
        enabled: false,
        sessionId: null,
        ticket: null,
        fairplay: {
            header: {
                Authorization: '',
            },
            appCertUrl: '',
            licenseUrl: '',
        },
        widevine: {
            header: {
                Authorization: '',
            },
            url: '',
        },
        playready: {},
    };

    this.paramsVO = {
        rco: {},
        setByPage: {},
        // tag application parameters
        TAG: {},
        // ad related parameters
        AD: {},
        // content related parameters
        CONTENT: {},
        CONTEXT: {},
        // skin related parameters
        SKIN: {},
        // user / page related parameters
        USER: {},
    };

    this.init = function () {
        let castSender;
        if (CBS.Registry?.ChromecastLocalEnv == 'local') {
            castSender = {};
        }

        this.drm = $.extend(this.drmTemplate, this.drm);

        if (this.drm.enabled) {
            this.paramsVO.CONTENT.drm = this.drm;
            if (this.millstone) {
                this.paramsVO.CONTENT.millstone = this.millstone;
            }
        }

        this.paramsVO.lowbandEnabled = this.lowbandEnabled;

        if (window.localStorage.getItem('metadata-video-tracking')) {
            const obj = JSON.parse(window.localStorage.getItem('metadata-video-tracking'));
            this.metaData = {
                ...this.metaData,
                ...obj,
            };
        }

        if (window.Chromecast || JSON.stringify(castSender) === '{}') {
            if (JSON.stringify(castSender) !== '{}') {
                castSender = new Chromecast();
                castSender.contentId = this.playerParams._contentID;
            }
        } else {
            console.log('Chromecast is not available in the current environment.');
        }

        // ABTest "homepage-descriptions"
        if (window.localStorage.getItem('abtest_homepage-descriptions')) {
            const hpageDescParams = JSON.parse(
                window.localStorage.getItem('abtest_homepage-descriptions'),
            );
            this.metaData = {
                ...this.metaData,
                ...hpageDescParams,
            };
            window.localStorage.removeItem('abtest_homepage-descriptions');
        }
        // END ABTest "homepage-descriptions"

        this.paramsVO = $.extend(true, this.playerParams, this.paramsVO);

        smartTag = new SmartTagAdapter(castSender, this.paramsVO, this.metaData, this.apiMetadata);
        if (initSmartTagPlugins) {
            initSmartTagPlugins(smartTag, this);
        }

        smartTag.contentId = this.playerParams._contentID;
        smartTag.enableCP = this.enableCP;
        smartTag.showId = this.showId;
        smartTag.baseUrl = this.baseUrl;

        let startCastSender = async () => {
            let geoLocation = null;
            try {
                await smartTag.smartTagReadyPromise;
                await smartTag.pinGatePromise;
                if (Domain.isDomestic()) {
                    //INTL doesn't have geolocation check
                    geoLocation = await new GeoLocationService().fetchLocation();
                }
            } catch (e) {
                console.log(e);
            }

            if (castSender && typeof castSender.start === 'function') {
                castSender.start(smartTag.api, geoLocation);
            } else {
                console.log(
                    'castSender is not properly initialized or does not have a start method.',
                );
            }
        };

        window['__onGCastApiAvailable'] = function (isAvailable) {
            if (isAvailable) {
                startCastSender();
            }
        };

        document.addEventListener('sp.blocking', function (e) {
            smartTag.hasAdBlocker = true;
            try {
                om.trackView({
                    adBlockStatus: 'true',
                });
            } catch (e) {}
        });
        document.addEventListener('sp.not_blocking', function (e) {
            smartTag.hasAdBlocker = false;
        });

        smartTag.onPlayerStateChanged = (playerState) => {
            if (playerState === 'PlayerState.PLAYING') {
                // signal global app User Profile video player is ready
                if (CBS.Registry.GlobalApp.UserProfile !== null) {
                    CBS.Registry.GlobalApp.UserProfile.App.videoPlayerEvent(
                        'PLAYER_STATE_CHANGE',
                        playerState,
                    );

                    const isMainOverlayOpen =
                        CBS.Registry.GlobalApp.UserProfile.App.$store.state.mainOverlay;
                    if (isMainOverlayOpen) {
                        smartTag.api.pageAction({ action: 'PageAction.PAUSE' });
                    }
                }
            }
        };

        window[this.paramsVO.jsNS] = smartTag.api;
    };
}
